module.exports = __webpack_public_path__ + "assets/img/img338.050d23fc.png";